import factory from "./factory";

const EndPoint = factory("Coach", "coaches");
const routes = [
  EndPoint("Clients", "clients"),
  EndPoint("ClientProfile", "client-profiles"),
  EndPoint("HabitPrograms", "habit-programs"),
  EndPoint("Commitments", "commitments"),
  EndPoint("AreaOfFocus", "area-of-growths"),
  EndPoint("PulseSurveys", "pulse-surveys"),
  EndPoint("PulseSurveyDiminsion", "pulse-surveys-dimensions"),
  EndPoint("PulseSurveyConstruct", "pulse-surveys-constructs"),
  EndPoint("PulseSurveyQuestions", "pulse-surveys-questions"),
  EndPoint("HabitProgramTemplateExercises", "template-exercises"),
  EndPoint("Courses", "courses"),
  EndPoint("CourseModules", "course-modules"),
  EndPoint("ModuleLessons", "module-lessons"),
  EndPoint("ClientInvitation", "client-invitations"),
  EndPoint("Cohort", "cohorts"),
  EndPoint("ClientCohorts", "client-cohorts"),
  EndPoint("ClientNotes", "coach-client-notes"), // Notes coach has taken on client
  EndPoint("ClientsNotes", "clients-notes"), // Notes client has taken
  EndPoint("ClientExercises", "client-exercises"),
  EndPoint("ClientPulseSurveys", "client-pulse-surveys"),
  EndPoint("MessagingRooms", "messaging-rooms"),
  EndPoint("Messages", "messages"),
  EndPoint("LessonResources", "exercise-resources"),
  EndPoint("ClientCourses", "client-courses"),
  EndPoint("ClientGoals", "client-goals"),
  EndPoint("ClientHabits", "client-custom-habits"),
  EndPoint("CreatedAssessments", "created-assessments"),
  EndPoint("Assessments", "assessments"),
  EndPoint("Attributes", "attributes"),
  EndPoint("TakenAssessments", "taken-assessments"),
  EndPoint("ClientKPIs", "kpis"),
  EndPoint("SubDomains", "subdomains"),
];

export default routes;
